/**
 * SubscriptionTypeService
 * Service for SubscriptionType entity operations
 * Route: api/subscriptiontypes
 * Controller: SubscriptionTypesController.cs
 */
import { CrudService } from '../base/CrudService';
export class SubscriptionTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SubscriptionTypeService.DEFAULT_SERVICE_PATH,
            basePath: SubscriptionTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== VIEW METHODS ====================
    async getAllViews() {
        const response = await this.getAllViewsRaw();
        return response.data ?? [];
    }
    getAllViewsRaw() {
        const url = this.buildUrl('views');
        return this.http.get(url);
    }
    async getViewById(id) {
        const response = await this.getViewByIdRaw(id);
        return response.data ?? null;
    }
    getViewByIdRaw(id) {
        const url = this.buildUrl(`views/${id}`);
        return this.http.get(url);
    }
}
SubscriptionTypeService.DEFAULT_SERVICE_PATH = 'suppliers';
SubscriptionTypeService.BASE_PATH = 'api/subscriptiontypes';
//# sourceMappingURL=SubscriptionTypeService.js.map